'use strict';
const Ajax = require('common/infra/ajax');

class API {
    getGroup(groupID) {
        return Ajax.GET(`/api/groups/${groupID}`);
    }

    getGroupRoles(groupID) {
        return Ajax.GET(`/api/groups/${groupID}/group-roles`);
    }

    getGroupRole(groupID, roleID) {
        return Ajax.GET(`/api/groups/${groupID}/group-roles/${roleID}`);
    }

    getMyGroups(options) {
        let query = '';
        if(options && options.excludeMembers) {
            query = '?exclude_members=true';
        }
        return Ajax.GET(`/api/my/groups${query}`);
    }

    create(groupJSON) {
        return Ajax.POST(`/api/groups`, groupJSON);
    }

    update(groupID, groupJSON) {
        return Ajax.PUT(`/api/groups/${groupID}`, groupJSON);
    }

    delete(groupID) {
        return Ajax.DELETE(`/api/groups/${groupID}`);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./common/infra/api/group.js